import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestmumbaitogoacabservice() {



    const cardData = {

keyword: "Best Mumbai to Goa Cab Service",

headingDescription:
    "Mumbai Airport Cab offers the Best Mumbai to Goa Cab Service for long-distance travel, family holidays, group tours, honeymoon trips, corporate travel, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Mumbai, and safe highway driving via the scenic Mumbai–Goa route, we ensure a premium, comfortable, and hassle-free travel experience at the best value.",

topPlaces: [
    {
        title: "Baga Beach",
        description:
            "Baga Beach is one of Goa’s most popular beaches, known for its vibrant nightlife, beach shacks, water sports, and energetic tourist atmosphere throughout the year."
    },
    {
        title: "Calangute Beach",
        description:
            "Calangute Beach is often called the Queen of Beaches and is famous for its long coastline, shopping stalls, water sports, and lively tourist crowd."
    },
    {
        title: "Anjuna Beach",
        description:
            "Anjuna Beach is known for its rocky shoreline, flea market, sunset views, and relaxed bohemian vibe attracting both domestic and international travelers."
    },
    {
        title: "Fort Aguada",
        description:
            "Fort Aguada is a well-preserved Portuguese fort overlooking the Arabian Sea, famous for its lighthouse, sea views, and historical significance from colonial times."
    },
    {
        title: "Dudhsagar Waterfalls",
        description:
            "Dudhsagar Waterfalls is one of India’s tallest waterfalls, located on the Goa–Karnataka border, known for its milky white cascade and dense forest surroundings."
    },
    {
        title: "Basilica of Bom Jesus",
        description:
            "Basilica of Bom Jesus is a UNESCO World Heritage Site in Old Goa, famous for its baroque architecture and preserved relics of St. Francis Xavier."
    },
    {
        title: "Palolem Beach",
        description:
            "Palolem Beach in South Goa is known for its calm waters, scenic beauty, beach huts, and peaceful environment ideal for relaxing vacations."
    },
    {
        title: "Chapora Fort",
        description:
            "Chapora Fort offers stunning sunset views over Vagator Beach and is a popular photography and Bollywood filming location."
    },
    {
        title: "Candolim Beach",
        description:
            "Candolim Beach is a peaceful North Goa beach known for clean shores, water sports, and a relaxed environment away from heavy crowds."
    },
    {
        title: "Se Cathedral",
        description:
            "Se Cathedral is one of the largest churches in Asia, admired for its Portuguese-Gothic architecture and deep historical importance in Old Goa."
    }
],



services: [
{
name: "Best Mumbai to Goa Cab Service",
description: "Best Mumbai to Goa Cab Service by 1Touch Cabs offers premium, safe, and reliable long-distance travel between Mumbai and Goa. We provide well-maintained vehicles including Sedan, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUV, and Luxury Cars. With experienced chauffeurs, door-to-door pickup, luggage assistance, and 24x7 availability, we ensure a smooth and comfortable road trip experience for families, tourists, corporate travelers, and groups.",
},
{
name: "Cheap Goa Cab Booking from Mumbai",
description: "Cheap Goa Cab Booking from Mumbai service provides budget-friendly outstation travel without compromising safety or comfort. 1Touch Cabs offers transparent pricing, economical fares, and reliable vehicles for one-way and round-trip journeys from Mumbai to Goa.",
},
{
name: "Online Goa Taxi Booking Mumbai",
description: "Online Goa Taxi Booking Mumbai allows passengers to quickly book cabs from Mumbai to Goa with instant confirmation. 1Touch Cabs offers flexible vehicle options, easy online reservations, and 24x7 customer support for hassle-free travel planning.",
},
{
name: "Mumbai to Goa Family Cab Service",
description: "Mumbai to Goa Family Cab Service ensures safe, comfortable, and spacious travel for families. We provide clean AC vehicles, professional drivers, and smooth highway rides for a relaxing journey to Goa.",
},
{
name: "Mumbai to Goa Innova Crysta Cab",
description: "Mumbai to Goa Innova Crysta Cab service offers premium comfort with spacious seating, luxury interiors, and smooth suspension, making it ideal for long-distance family and group travel.",
},
{
name: "Mumbai to Goa Chauffeur Driven Cab",
description: "Mumbai to Goa Chauffeur Driven Cab service provides professional driver assistance for a stress-free journey. Our experienced chauffeurs ensure safe driving, route efficiency, and comfortable long-distance travel.",
},
{
name: "Mumbai to Goa Road Trip Taxi",
description: "Mumbai to Goa Road Trip Taxi service is designed for travelers who enjoy scenic highway journeys. 1Touch Cabs ensures comfortable vehicles, safe driving, and flexible stops for a memorable road trip experience.",
},
{
name: "24x7 Goa Cab Service Mumbai",
description: "24x7 Goa Cab Service Mumbai offers round-the-clock availability for booking cabs from Mumbai to Goa. Whether early morning or late night, we ensure reliable transportation anytime.",
},
{
name: "Mumbai to Goa Corporate Cab Service",
description: "Mumbai to Goa Corporate Cab Service provides professional transportation solutions for business travelers. We offer punctual pickups, comfortable executive vehicles, and reliable long-distance travel for corporate needs.",
},

{
name: "Thane to Goa Cabs",
description: "Thane to Goa Cabs service provides safe, comfortable, and affordable long-distance travel from Thane to Goa with multiple vehicle options and professional chauffeurs for a smooth journey.",
},
{
name: "Thane to Goa Cab Service",
description: "Thane to Goa Cab Service offers reliable outstation travel with clean AC vehicles, experienced drivers, and 24x7 availability for families and groups traveling to Goa.",
},
{
name: "Thane to Goa Taxi Service",
description: "Thane to Goa Taxi Service ensures safe and convenient intercity travel with professional chauffeurs and well-maintained vehicles for a stress-free road trip.",
},
{
name: "Thane to Goa Cab Booking",
description: "Thane to Goa Cab Booking service allows easy online reservations with instant confirmation, flexible vehicle choices, and transparent pricing.",
},
{
name: "Thane to Goa One Way Cab",
description: "Thane to Goa One Way Cab service provides cost-effective travel without return fare charges, ideal for budget-friendly Goa trips.",
},
{
name: "Thane to Goa Innova Cab",
description: "Thane to Goa Innova Cab service offers spacious and comfortable travel for families and groups with extra luggage space and smooth highway driving.",
},
{
name: "Thane to Goa Ertiga Cab",
description: "Thane to Goa Ertiga Cab service provides an economical and comfortable travel option for small families and group journeys to Goa.",
},

{
name: "Kalyan Dombivli to Goa Cabs",
description: "Kalyan Dombivli to Goa Cabs service ensures safe and reliable outstation travel with professional chauffeurs and well-maintained vehicles for long journeys.",
},
{
name: "Kalyan to Goa Cab Service",
description: "Kalyan to Goa Cab Service offers convenient intercity travel with multiple vehicle options and 24x7 booking support for smooth Goa trips.",
},
{
name: "Dombivli to Goa Taxi",
description: "Dombivli to Goa Taxi service provides dependable and comfortable long-distance travel with experienced drivers and clean AC vehicles.",
},
{
name: "Kalyan to Goa One Way Cab",
description: "Kalyan to Goa One Way Cab service offers affordable single-trip transportation without return charges for budget travelers.",
},
{
name: "Dombivli to Goa Cab Booking",
description: "Dombivli to Goa Cab Booking service enables quick online booking with instant confirmation and flexible travel options.",
},
{
name: "Kalyan Dombivli to Goa Taxi Service",
description: "Kalyan Dombivli to Goa Taxi Service provides safe, reliable, and comfortable intercity travel with professional chauffeurs.",
},
{
name: "Kalyan to Goa Innova Cab",
description: "Kalyan to Goa Innova Cab service offers premium comfort and spacious seating ideal for long-distance family and group travel.",
},
{
name: "Dadar to Goa Cabs",
description: "Dadar to Goa Cabs service provides convenient pickup from Dadar with safe and comfortable long-distance travel to Goa.",
},
{
name: "Dadar to Goa Cab Service",
description: "Dadar to Goa Cab Service ensures reliable outstation travel with professional drivers and well-maintained vehicles.",
},
{
name: "Dadar to Goa Taxi Booking",
description: "Dadar to Goa Taxi Booking service allows easy and quick cab reservations with transparent pricing and 24x7 support."
}
],

tableData: [
["Best Mumbai to Goa Cab Service","Cheap Goa Cab Booking from Mumbai"],
["Online Goa Taxi Booking Mumbai","Mumbai to Goa Family Cab Service"],
["Mumbai to Goa Innova Crysta Cab","Mumbai to Goa Chauffeur Driven Cab"],
["Mumbai to Goa Road Trip Taxi","24x7 Goa Cab Service Mumbai"],
["Mumbai to Goa Corporate Cab Service","Thane to Goa Cab Service"],
["Thane to Goa Taxi Service","Thane to Goa One Way Cab"],
["Thane to Goa Innova Cab","Thane to Goa Ertiga Cab"],
["Kalyan to Goa Cab Service","Dombivli to Goa Taxi"],
["Kalyan to Goa One Way Cab","Dadar to Goa Cab Service"],
["Kalyan Dombivli to Goa Taxi Service","Dadar to Goa Taxi Booking"]
],


















whychoose: [
    {
        WhyChooseheading: "Best Mumbai to Goa Cab Service for Comfortable Travel",
        WhyChoosedescription: "Mumbai Airport Cabs provides reliable Mumbai to Goa Cab Services with professional drivers, clean vehicles, flexible pickup locations, and comfortable long-distance travel options."
    },
    {
        WhyChooseheading: "Direct Door-to-Door Transportation",
        WhyChoosedescription: "Enjoy convenient pickup from your home, hotel, office, Mumbai Airport, Navi Mumbai, Thane, or any location in Mumbai and get dropped directly at your Goa destination."
    },
    {
        WhyChooseheading: "Ideal for Family Vacations and Goa Holidays",
        WhyChoosedescription: "Whether you are planning a beach holiday, honeymoon, family vacation, friends trip, corporate outing, or weekend getaway, our cab service ensures a hassle-free journey."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Choose from Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and luxury vehicles based on your group size and luggage requirements."
    },
    {
        WhyChooseheading: "One Way and Round Trip Cab Booking",
        WhyChoosedescription: "We offer one-way cabs, round-trip bookings, multi-day packages, customized Goa tours, and airport-to-Goa transfers according to your travel needs."
    },
    {
        WhyChooseheading: "Scenic Mumbai to Goa Road Journey",
        WhyChoosedescription: "The Mumbai to Goa route covers approximately 550-590 km and typically takes around 10 to 14 hours depending on traffic, route, and weather conditions. :contentReference[oaicite:0]{index=0}"
    },
    {
        WhyChooseheading: "Experienced Drivers for Konkan Routes",
        WhyChoosedescription: "Our chauffeurs are experienced on Mumbai-Goa highway routes and ensure safe, smooth, and stress-free travel throughout the journey."
    },
    {
        WhyChooseheading: "Affordable and Transparent Pricing",
        WhyChoosedescription: "Mumbai to Goa one-way cab fares generally start from budget-friendly rates depending on vehicle type, travel date, and route preferences. :contentReference[oaicite:1]{index=1}"
    }
]
};

const faqData = [
    {
        question: "Why is Mumbai Airport Cabs considered one of the best Mumbai to Goa cab services?",
        answer: "We offer comfortable vehicles, professional drivers, flexible pickup options, doorstep service, and customized travel solutions for every type of traveler."
    },
    {
        question: "How far is Goa from Mumbai by road?",
        answer: "The journey is approximately 550 to 590 kilometers and usually takes around 10 to 14 hours depending on traffic and road conditions. :contentReference[oaicite:2]{index=2}"
    },
    {
        question: "Can I book a one-way cab from Mumbai to Goa?",
        answer: "Yes, one-way cab services are available along with round-trip and customized Goa holiday packages."
    },
    {
        question: "Which vehicle is best for Mumbai to Goa travel?",
        answer: "Sedan cars are ideal for small families, while Ertiga, Innova, Innova Crysta, Kia Carens, Tempo Travellers, and Mini Buses are suitable for larger groups."
    },
    {
        question: "Can I get pickup from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, Navi Mumbai, Thane, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Are Tempo Travellers available for Goa group tours?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate outings, bachelor trips, and tourist groups."
    },
    {
        question: "Can sightseeing stops be included during the trip?",
        answer: "Yes, customers can customize their itinerary and include Konkan sightseeing, meal breaks, beaches, waterfalls, forts, and tourist attractions."
    },
    {
        question: "Do you provide direct hotel and resort drop in Goa?",
        answer: "Yes, doorstep drop services are available at hotels, resorts, villas, beaches, and tourist destinations across North and South Goa."
    },
    {
        question: "Is advance booking recommended for Mumbai to Goa cab travel?",
        answer: "Yes, advance booking is highly recommended during weekends, holidays, Christmas, New Year, and peak tourist seasons."
    },
    {
        question: "How can I book the Best Mumbai to Goa Cab Service?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rohan Mehta",
        feedback:
            "We booked a Mumbai to Goa cab for our family vacation and had an amazing experience. The vehicle was clean, comfortable, and the driver was highly professional.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Pooja Kulkarni",
        feedback:
            "Our Goa trip was smooth from start to finish. The cab arrived on time, the journey was comfortable, and the service exceeded our expectations.",
        rating: 5
    }
];


















   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Mumbai to Goa Cab Service",
  "image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-goa-cab-service.jpg",
  "description": "Book the best Mumbai to Goa cab service for safe, comfortable, and reliable outstation travel. Mumbai Airport Cabs offers premium chauffeur-driven taxis including Innova Crysta and family cab options with 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "10200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹11,999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/best-mumbai-to-goa-cab-service"
  }
};



    return (
        <div>


<Helmet>
  <title>Best Mumbai to Goa Cab Service | Luxury & Family Taxi | +91 9545731161</title>

  <meta
    name="description"
    content="Book the best Mumbai to Goa cab service for safe road trips. Affordable family taxis, Innova Crysta, and chauffeur-driven cars with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Best Mumbai to Goa Cab Service, Cheap Goa Cab Booking from Mumbai, Online Goa Taxi Booking Mumbai, Mumbai to Goa Family Cab Service, Mumbai to Goa Innova Crysta Cab, Mumbai to Goa Chauffeur Driven Cab, Mumbai to Goa Road Trip Taxi, 24x7 Goa Cab Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bestmumbaitogoacabservice;